import { customPalette } from "../../theme/theme";

import { JSX } from "react";

import Box from "@mui/material/Box";

import { Subtitle } from "./Subtitle";
import { Title } from "./Title";

export function CustomPageHeading({
  text,
  subtitle,
}: {
  text: string;
  subtitle?: string | undefined | null;
}): JSX.Element {
  return (
    <Box
      sx={{
        marginTop: "1rem",
        pb: "1rem",
        mb: "1rem",
        borderBottom: "1px solid " + customPalette.secondary.light,
      }}
    >
      {text ? <Title text={text} /> : null}
      {subtitle ? <Subtitle text={subtitle} /> : null}
    </Box>
  );
}
